// frontend/src/App.js
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/common/Login/Login";
import Register from "./pages/common/Register/Register";
import ProtectedRoute from "./components/ProtectedRoute";

// Role-specific dashboards
import AdminDashboard from "./pages/admin/Dashboard/Dashboard";
import ProjectAssociateDashboard from "./pages/project-associate/Dashboard/Dashboard";
import ManageUsers from "./pages/admin/ManageUsers/ManageUsers";

// Role-aware wrapper components
import RoleAwareProfile from "./components/RoleAware/RoleAwareProfile";
import RoleAwareCreateProject from "./components/RoleAware/RoleAwareCreateProject";
import RoleAwareManageProjects from "./components/RoleAware/RoleAwareManageProjects";
import RoleAwareProjectPage from "./components/RoleAware/RoleAwareProjectPage";
import RoleAwareCAF from "./components/RoleAware/RoleAwareCAF";
import RoleAwarePFR from "./components/RoleAware/RoleAwarePFR";
import RoleAwareEMP from "./components/RoleAware/RoleAwareEMP";
import CAFView from "./pages/common/CAF/CAFView";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Admin Routes */}
        <Route
          path="/admin"
          element={<ProtectedRoute allowedRoles={["admin"]} />}
        >
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="manage-users" element={<ManageUsers />} />
          <Route path="profile" element={<RoleAwareProfile role="admin" />} />
          <Route
            path="create-project"
            element={<RoleAwareCreateProject role="admin" />}
          />
          <Route
            path="manage-projects"
            element={<RoleAwareManageProjects role="admin" />}
          />
          <Route
            path="projects/:projectId"
            element={<RoleAwareProjectPage role="admin" />}
          />
          <Route path="caf" element={<RoleAwareCAF role="admin" />} />
          <Route path="pfr" element={<RoleAwarePFR role="admin" />} />
          <Route path="emp" element={<RoleAwareEMP role="admin" />} />
        </Route>

        {/* Project Associate Routes */}
        <Route
          path="/project_associate"
          element={<ProtectedRoute allowedRoles={["project_associate"]} />}
        >
          <Route path="dashboard" element={<ProjectAssociateDashboard />} />
          <Route
            path="profile"
            element={<RoleAwareProfile role="project_associate" />}
          />
          <Route
            path="create-project"
            element={<RoleAwareCreateProject role="project_associate" />}
          />
          <Route
            path="manage-projects"
            element={<RoleAwareManageProjects role="project_associate" />}
          />
          <Route
            path="projects/:projectId"
            element={<RoleAwareProjectPage role="project_associate" />}
          />
          <Route
            path="caf"
            element={<RoleAwareCAF role="project_associate" />}
          />
          <Route
            path="pfr"
            element={<RoleAwarePFR role="project_associate" />}
          />
          <Route
            path="emp"
            element={<RoleAwareEMP role="project_associate" />}
          />
        </Route>

        {/* Catch-all route for any other path */}
        <Route path="*" element={<Navigate to="/login" replace />} />
        <Route path="/caf/:projectId" element={<RoleAwareCAF />} />

        {/* Route for viewing CAF */}
        <Route path="/caf/view/:cafId" element={<CAFView />} />
      </Routes>
    </Router>
  );
}

export default App;
